var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",attrs:{"role":"button"},on:{"click":_vm.onFavoriteClick}},[_c('span',{staticClass:"icon is-small mr-2"},[_c('i',{class:[
        'fa',
        _vm.isFavorite ? 'fa-heart' : 'fa-heart-o',
        { 'text-red': _vm.isFavorite, 'animation-pulse': _vm.isFavorite } ]})]),(_vm.hasLabel)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }